import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCompanyListWithClaimFormService } from "../../api/companyApi";

export const getCompanyListWithClaimForm = createAsyncThunk(
  "company/getCompanyListWithClaimForm",
  async (_, { dispatch }) => {
    dispatch(resetReducer());
    const response = await getCompanyListWithClaimFormService();

    return response.data;
  }
);

const companySlice = createSlice({
  name: "company",
  initialState: {
    companyLoader: false,
    companyList: [],
    status: null,
    message: "",
  },
  reducers: {
    resetReducer: (state) => {
      state.companyLoader = false;
      state.companyList = [];
      state.status = null;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyListWithClaimForm.pending, (state, action) => {
        state.companyLoader = true;
        state.status = false;
      })
      .addCase(getCompanyListWithClaimForm.fulfilled, (state, action) => {
        state.companyList = action.payload.data;
        state.message = action.payload.msg;
        state.companyLoader = false;
        state.status = true;
      })
      .addCase(getCompanyListWithClaimForm.rejected, (state, action) => {
        state.companyLoader = false;
        state.status = false;
      });
  },
});

export const { resetReducer } = companySlice.actions;
export default companySlice.reducer;
